var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_116)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H87V87H0V0V0Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8755 72.7036L29.5334 68.6744C30.8178 70.9517 31.9862 72.8785 34.7889 72.8785C37.4754 72.8785 39.1691 71.8276 39.1691 67.74V39.9414H47.3449V67.8556C47.3449 76.3236 42.3812 80.178 35.1394 80.178C28.599 80.178 24.8025 76.7906 22.8754 72.7029",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7857 71.8275L58.4428 67.9731C60.1952 70.835 62.4728 72.9372 66.5021 72.9372C69.8897 72.9372 72.05 71.2435 72.05 68.9075C72.05 66.1043 69.8309 65.1114 66.0932 63.4767L64.0498 62.6001C58.1511 60.0894 54.2382 56.9358 54.2382 50.2781C54.2382 44.1461 58.9101 39.474 66.2103 39.474C71.408 39.474 75.1455 41.2845 77.8316 46.015L71.466 50.1027C70.0643 47.5918 68.5464 46.5991 66.2105 46.5991C63.816 46.5991 62.2975 48.1175 62.2975 50.1027C62.2975 52.5556 63.816 53.5486 67.3197 55.0671L69.3635 55.9431C76.3131 58.9216 80.226 61.9581 80.226 68.7906C80.226 76.1494 74.4445 80.1787 66.6775 80.1787C59.0856 80.1787 54.1799 76.5581 51.7859 71.8275",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.35d97525ebed85d3e6c54f24c17a5d5f.svg";
export { ForwardRef as ReactComponent };